/* eslint-disable @typescript-eslint/no-explicit-any */
export const groupBy = (items: any[], key: string) =>
    items.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [...(result[item[key]] || []), item]
        }),
        {}
    );
